export default "<app-header></app-header>\n<div class=\"_container\">\n\t<router-outlet></router-outlet>\n</div>\n\n<app-footer></app-footer>\n"